var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vue-codeditor',{attrs:{"mode":_vm.option.language,"theme":"chrome"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_vm._v(" "),_c('b-button',{staticClass:"mt-3",attrs:{"variant":"primary"},on:{"click":_vm.format}},[_vm._v("Форматировать")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }